export default __webpack_public_path__ + "static/media/logo.d47a7431.svg";